import React from 'react';

const IronManInterface = () => {
  return (
    <svg 
      viewBox="0 0 800 600" 
      className="w-full h-auto rounded-xl overflow-hidden" 
      xmlns="http://www.w3.org/2000/svg"
    >
      {/* Background */}
      <rect width="800" height="600" fill="#121212" />
      
      {/* Grid pattern */}
      <pattern id="smallGrid" width="20" height="20" patternUnits="userSpaceOnUse">
        <path d="M 20 0 L 0 0 0 20" fill="none" stroke="#ffffff" strokeOpacity="0.05" strokeWidth="0.5"/>
      </pattern>
      <rect width="100%" height="100%" fill="url(#smallGrid)" />
      
      {/* Radial Glow */}
      <defs>
        <radialGradient id="centerGlow" cx="0.5" cy="0.5" r="0.5" fx="0.5" fy="0.5">
          <stop offset="0%" stopColor="#f43f5e" stopOpacity="0.5" />
          <stop offset="100%" stopColor="#121212" stopOpacity="0" />
        </radialGradient>
      </defs>
      <circle cx="400" cy="300" r="250" fill="url(#centerGlow)" />
      
      {/* Circle Interface Elements */}
      <g className="interface-elements">
        {/* Main outer circle */}
        <circle 
          cx="400" 
          cy="300" 
          r="220" 
          fill="none" 
          stroke="#f43f5e" 
          strokeWidth="2" 
          strokeOpacity="0.7" 
          strokeDasharray="2,4"
        >
          <animateTransform 
            attributeName="transform" 
            type="rotate" 
            from="0 400 300" 
            to="360 400 300" 
            dur="120s" 
            repeatCount="indefinite" 
            additive="sum"
          />
        </circle>
        
        {/* Secondary circles */}
        <circle 
          cx="400" 
          cy="300" 
          r="180" 
          fill="none" 
          stroke="#f43f5e" 
          strokeWidth="1.5" 
          strokeOpacity="0.5"
        >
          <animateTransform 
            attributeName="transform" 
            type="rotate" 
            from="360 400 300" 
            to="0 400 300" 
            dur="90s" 
            repeatCount="indefinite" 
            additive="sum"
          />
        </circle>
        
        <circle 
          cx="400" 
          cy="300" 
          r="140" 
          fill="none" 
          stroke="#f43f5e" 
          strokeWidth="1" 
          strokeOpacity="0.4" 
          strokeDasharray="8,2" 
        >
          <animateTransform 
            attributeName="transform" 
            type="rotate" 
            from="0 400 300" 
            to="360 400 300" 
            dur="60s" 
            repeatCount="indefinite" 
            additive="sum"
          />
        </circle>
        
        {/* Central Arc Reactor-like element */}
        <circle cx="400" cy="300" r="70" fill="#121212" stroke="#f43f5e" strokeWidth="3" />
        <circle cx="400" cy="300" r="60" fill="none" stroke="#f43f5e" strokeWidth="2" strokeOpacity="0.7" />
        <circle cx="400" cy="300" r="50" fill="none" stroke="#f43f5e" strokeWidth="1.5" strokeOpacity="0.5" />
        <circle cx="400" cy="300" r="40" fill="#f43f5e" fillOpacity="0.2">
          <animate 
            attributeName="r" 
            values="40;45;40" 
            dur="2s" 
            repeatCount="indefinite" 
          />
          <animate 
            attributeName="fill-opacity" 
            values="0.2;0.3;0.2" 
            dur="2s" 
            repeatCount="indefinite" 
          />
        </circle>
        
        {/* Pulsing Center */}
        <circle cx="400" cy="300" r="10" fill="#f43f5e">
          <animate 
            attributeName="r" 
            values="10;15;10" 
            dur="2s" 
            repeatCount="indefinite" 
          />
          <animate 
            attributeName="fill-opacity" 
            values="1;0.8;1" 
            dur="2s" 
            repeatCount="indefinite" 
          />
        </circle>
        
        {/* Orbit Points */}
        {[0, 60, 120, 180, 240, 300].map((angle, i) => (
          <g key={i}>
            <circle 
              cx={400 + 180 * Math.cos(angle * Math.PI / 180)} 
              cy={300 + 180 * Math.sin(angle * Math.PI / 180)} 
              r="6" 
              fill="#f43f5e"
            >
              <animate 
                attributeName="fill-opacity" 
                values="1;0.5;1" 
                dur={`${1 + i * 0.2}s`} 
                repeatCount="indefinite" 
              />
            </circle>
          </g>
        ))}
        
        {/* Inner connecting lines */}
        <g strokeOpacity="0.4" stroke="#f43f5e" strokeWidth="1">
          <line x1="400" y1="230" x2="400" y2="210" />
          <line x1="400" y1="370" x2="400" y2="390" />
          <line x1="330" y1="300" x2="310" y2="300" />
          <line x1="470" y1="300" x2="490" y2="300" />
        </g>
        
        {/* Data elements */}
        <g className="data-elements">
          {/* Top */}
          <rect x="360" y="170" width="80" height="25" fill="#121212" stroke="#f43f5e" strokeWidth="1" rx="2" />
          <text x="400" y="187" textAnchor="middle" fill="#f43f5e" fontSize="12" fontFamily="monospace">SYSTEM READY</text>
          
          {/* Bottom */}
          <rect x="340" y="405" width="120" height="25" fill="#121212" stroke="#f43f5e" strokeWidth="1" rx="2" />
          <text x="400" y="422" textAnchor="middle" fill="#f43f5e" fontSize="12" fontFamily="monospace">AINOUS CORE ENGAGED</text>
          
          {/* Left */}
          <rect x="170" y="290" width="120" height="20" fill="#121212" stroke="#f43f5e" strokeWidth="1" rx="2" />
          <text x="230" y="305" textAnchor="middle" fill="#f43f5e" fontSize="10" fontFamily="monospace">NEURAL LINK ACTIVE</text>
          
          {/* Right */}
          <rect x="510" y="290" width="120" height="20" fill="#121212" stroke="#f43f5e" strokeWidth="1" rx="2" />
          <text x="570" y="305" textAnchor="middle" fill="#f43f5e" fontSize="10" fontFamily="monospace">QUANTUM SYNC: 100%</text>
        </g>
        
        {/* Scanning lines */}
        <line x1="300" y1="150" x2="500" y2="150" stroke="#f43f5e" strokeWidth="1" strokeOpacity="0.7">
          <animate attributeName="y1" values="150;450;150" dur="8s" repeatCount="indefinite" />
          <animate attributeName="y2" values="150;450;150" dur="8s" repeatCount="indefinite" />
          <animate attributeName="stroke-opacity" values="0.7;0.2;0.7" dur="8s" repeatCount="indefinite" />
        </line>
        
        {/* Corner elements */}
        <path d="M 150,150 L 150,170 L 170,170" fill="none" stroke="#f43f5e" strokeWidth="2" />
        <path d="M 650,150 L 650,170 L 630,170" fill="none" stroke="#f43f5e" strokeWidth="2" />
        <path d="M 150,450 L 150,430 L 170,430" fill="none" stroke="#f43f5e" strokeWidth="2" />
        <path d="M 650,450 L 650,430 L 630,430" fill="none" stroke="#f43f5e" strokeWidth="2" />
        
        {/* Status bars */}
        <g className="status-bars">
          <rect x="180" y="480" width="150" height="10" fill="none" stroke="#f43f5e" strokeWidth="1" rx="2" />
          <rect x="180" y="480" width="120" height="10" fill="#f43f5e" fillOpacity="0.5" rx="2">
            <animate attributeName="width" values="0;120;120" dur="2s" begin="0s" fill="freeze" />
          </rect>
          <text x="180" y="475" fill="#f43f5e" fontSize="10">PROCESSING POWER</text>
          
          <rect x="470" y="480" width="150" height="10" fill="none" stroke="#f43f5e" strokeWidth="1" rx="2" />
          <rect x="470" y="480" width="135" height="10" fill="#f43f5e" fillOpacity="0.5" rx="2">
            <animate attributeName="width" values="0;135;135" dur="2.5s" begin="0s" fill="freeze" />
          </rect>
          <text x="470" y="475" fill="#f43f5e" fontSize="10">LEARNING CAPACITY</text>
        </g>
        
        {/* Moving particles */}
        <g className="particles">
          {[...Array(20)].map((_, i) => (
            <circle key={i} r="1.5" fill="#f43f5e">
              <animate 
                attributeName="cx" 
                values={`${400 + 180 * Math.cos((i * 18) * Math.PI / 180)};${400 + 180 * Math.cos(((i * 18) + 180) * Math.PI / 180)};${400 + 180 * Math.cos((i * 18) * Math.PI / 180)}`} 
                dur={`${3 + i % 5}s`} 
                repeatCount="indefinite" 
              />
              <animate 
                attributeName="cy" 
                values={`${300 + 180 * Math.sin((i * 18) * Math.PI / 180)};${300 + 180 * Math.sin(((i * 18) + 180) * Math.PI / 180)};${300 + 180 * Math.sin((i * 18) * Math.PI / 180)}`} 
                dur={`${3 + i % 5}s`} 
                repeatCount="indefinite" 
              />
              <animate 
                attributeName="fill-opacity" 
                values="1;0.3;1" 
                dur={`${3 + i % 5}s`} 
                repeatCount="indefinite" 
              />
            </circle>
          ))}
        </g>
        
        {/* Text Labels */}
        <text x="400" y="65" textAnchor="middle" fill="#ffffff" fontSize="24" fontWeight="bold">AINOUS AI INTERFACE</text>
        <text x="400" y="90" textAnchor="middle" fill="#f43f5e" fontSize="14">ADVANCED NEURAL NETWORK</text>
        
        <text x="400" y="530" textAnchor="middle" fill="#ffffff" fontSize="14" fontWeight="bold">MODEL XD-42 QUANTUM PROCESSOR</text>
        <text x="400" y="550" textAnchor="middle" fill="#f43f5e" fontSize="10">COGNITIVE ENHANCEMENT SYSTEM</text>
      </g>
    </svg>
  );
};

export default IronManInterface;